import React from 'react';
import WarningIcon from '@material-ui/icons/Warning';

function NotFound() {
    return (
        <div style={{ minHeight: '500px', position: 'relative' }}>
            <WarningIcon />
        </div>
    );
}

export default NotFound;